<script setup lang="ts">
import LabelView from '../LabelView.vue';
import { type CardLabel } from '@itinerary/types';

defineProps<{
    labels?: CardLabel[];
}>();
</script>

<template>
    <div class="card-labels-container">
        <LabelView v-for="label in labels || []" :key="label.title" :label />
    </div>
</template>

<style lang="scss" scoped>
.card-labels-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 4px 0;
    :not(:last-child) {
        margin-left: 4px;
    }
}
</style>
